import { Container, Divider, Typography } from "@mui/material";
import {
  getEvChargerInclusion,
  getSelectedAddress,
  getSelectedProduct,
  getUserDetails,
  getUserProperty,
} from "domain/core/selectors";
import { ProductName } from "domain/core/types";
import { sendAnalyticsPageView } from "lib/util";
import { useReduxState } from "re-reduced";
import React, { useEffect } from "react";
import { persistor } from "store/configureStore";
import { EvPlanCompletion } from "ui/compounds/success/EvPlanCompletion";
import { FuelRewardsCompletion } from "ui/compounds/success/FuelRewardsCompletion";

const stateSelectorMap = {
  userDetails: getUserDetails,
  propertyDetails: getUserProperty,
  address: getSelectedAddress,
  selectedProduct: getSelectedProduct,
  includeEVCharger: getEvChargerInclusion,
};

export const Success: React.FC = () => {
  const reduxState = useReduxState(stateSelectorMap);

  useEffect(() => {
    sendAnalyticsPageView("Great, your application has been submitted");
    // Clear all local storage
    persistor.flush();
    persistor.purge();
  }, []);

  const switchingProvider =
    reduxState.propertyDetails.situation === "switch_provider";

  return (
    <Container component="main">
      <Typography variant="h2">
        Great, your application has been submitted
      </Typography>
      {reduxState.selectedProduct === ProductName.Z_ELECTRIC_REWARDS && (
        <>
          <FuelRewardsCompletion
            preferredName={reduxState.userDetails.prefName}
            selectedProduct={reduxState.selectedProduct}
            address={reduxState.address}
            isSwitching={switchingProvider}
          />
        </>
      )}

      {reduxState.selectedProduct === ProductName.Z_EV && (
        <EvPlanCompletion
          address={reduxState.address}
          charger={reduxState.includeEVCharger}
        />
      )}

      <Divider />
    </Container>
  );
};
